<template>
  <v-form>
    <v-row>
      <v-col cols="11">
        <v-row>
          <v-col cols="12">
            <gg-select
              outlined
              :items="select.action"
              item-text="title"
              item-value="value"
              v-model="model.action"
              @change="changed"
            ></gg-select>
          </v-col>
          <v-col cols="12">
            <gg-text-field
              outlined
              label="Redirect to email"
              v-if="model.action === 'deliver'"
              v-model="model.dest"
              v-validate="validation_rules.redirect"
              data-vv-name="deliver"
              data-vv-as="Redirect to email"
              :error-messages="errors.collect('deliver')"
              @input="changed"
            ></gg-text-field>
            <gg-text-field
              outlined
              label="Fail with message"
              v-if="model.action === 'fail'"
              v-model="model.dest"
              v-validate="validation_rules.fail"
              data-vv-name="fail"
              data-vv-as="Fail with message"
              :error-messages="errors.collect('fail')"
              @input="changed"
            ></gg-text-field>
            <gg-text-field
              outlined
              label="Deliver to folder"
              v-if="model.action === 'save'"
              v-model="model.dest"
              v-validate="validation_rules.save"
              data-vv-name="save"
              data-vv-as="Deliver to folder"
              :error-messages="errors.collect('save')"
              @input="changed"
              @click.stop="openTree"
            ></gg-text-field>
            <v-treeview v-if="model.action === 'save' && isTreeOpen"
                        v-model="tree"
                        :load-children="getFolders"
                        :items="folders"
                        activatable
                        item-text="name"
                        item-key="relpath"
                        open-on-click
                        @input="changed"
                        :active.sync="active">
              <template slot="prepend" slot-scope="{ item, open }">
                <v-icon v-if="!item.file">
                  {{ open ? 'mdi-folder' : 'mdi-folder' }}
                </v-icon>
              </template>
            </v-treeview>
            <gg-text-field
              outlined
              label="Pipe to a program"
              v-if="model.action === 'pipe'"
              v-model="model.dest"
              v-validate="validation_rules.pipe"
              data-vv-name="pipe"
              data-vv-as="Pipe to a program"
              :error-messages="errors.collect('pipe')"
              @input="changed"
            ></gg-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="text-right" cols="1" >
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <gg-btn v-on="on" elevation="0" text @click="addRuleItem">
              <v-icon>mdi-plus</v-icon>
            </gg-btn>
          </template>
          <span>Add new action</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <gg-btn v-on="on" elevation="0" text @click="removeRuleItem">
              <v-icon>mdi-minus</v-icon>
            </gg-btn>
          </template>
          <span>Delete action</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Actions',
  data: () => ({
    isTreeOpen: false,
    tree: [],
    folders: [
      {
        id: 0,
        root: true,
        name: 'Select a folder',
        children: []
      }
    ],
    active: [],

    select: {
      action: [
        {
          value: 'save "/dev/null"',
          title: 'Discard message'
        },
        {
          value: 'deliver',
          title: 'Redirect to Email'
        },
        {
          value: 'fail',
          title: 'Fail with message'
        },
        {
          value: 'finish',
          title: 'Stop processing rules'
        },
        {
          value: 'save',
          title: 'Deliver to folder'
        },
        {
          value: 'pipe',
          title: 'Pipe to a program'
        }
      ],
    },
    model: {
      action: 'save "/dev/null"',
      dest: ''
    },
    validation_rules: {
      redirect: { required: true },
      fail: { required: true },
      save: { required: true },
      pipe: { required: true }
    }
  }),
  props: {
    index: {
      type: Object
    },
    action: {
      type: Object
    }
  },
  methods: {
    ...mapActions(['cpanel_uapi', 'reportError']),
    changed () {
      this.$nextTick(() => {
        let action = {}
        for (let prop in this.model) {
          if (this.model.hasOwnProperty(prop)) {
            action['index'] = this.index.id
            action[prop] = {
              value: this.model[prop],
              rule_name: `${prop}${this.index.id}`
            }
          }
        }
        this.$emit('changed', action)
      })
    },
    addRuleItem () {
      this.$emit('add')
    },
    removeRuleItem () {
      this.$emit('remove', this.index)
    },
    openTree () {
      this.isTreeOpen = true
    },
    async getFolders () {
      const active_item = arguments[0]
      const dir = active_item ? active_item.fullpath : 'mail'
      const account = active_item ? active_item.text : ''
      const data = {
        uapi_module: 'Email',
        uapi_function: 'browse_mailbox',
        dir,
        account
      }
      try {
        const response = await this.cpanel_uapi({ ...data })
        response.payload.data.forEach((item, index) => {
          active_item.children.push({
            id: index,
            name: item.file,
            relpath: item.relpath,
            children: item.isleaf ? undefined : [],
          })
        })
      } catch (e) {
        this.reportError(e)
      }
    }
  },
  inject: ['parentValidator'],
  watch: {
    active (val) {
      if (val[0] !== undefined) {
        this.model.dest = val[0]
        this.changed()
      }
    }
  },
  created () {
    this.$validator = this.parentValidator

    if (this.action !== undefined) {
      if (this.action.action === 'save' && this.action.dest === '/dev/null') {
        this.model.action = 'save "/dev/null"'
        this.model.dest = ''
      } else {
        this.model.action = this.action.action
        this.model.dest = this.action.dest
      }
    }
  },
  mounted () {
    // this.toggleTree()
    this.changed()
  }
}
</script>
